/*
* @Author: yongwenhao
* @Date: 2020-04-07 13:15:33
* @describe: 医学事务
*/
<template>
    <ItemWarp :dataInfo="dataInfo" :isClass="isClass" :isFSP="true"></ItemWarp>
</template>

<script>
    import serviceData from '../../js/data'
    import ItemWarp from './components/item-warp'
    export default {
        name: "FSP",
        props: {},
        components: {ItemWarp},
        data() {
            return {
                dataInfo: serviceData.FSP,
                isClass: true,
            }
        }
    }
</script>

<style lang='less' scoped>

</style>